<template>
  <article class="contents-content">
    <div class="contents-content__content">
      <div class="content-in-area">
        <h1 class="content__title">주보 등록하기</h1>
        <p/>
        주보는 파일 이름을 <b>날짜(형식: yyyyMMdd.pdf)</b>로 변경해서 올려주세요
        <p/>
        그 외에는 파일 이름을 <b>영문, 숫자, 언더바</b>로 변경해서 올려주세요<b>(한글 x)</b>
        <p/>
        <v-sheet
          tabindex="0"
          title="Click to grap a file from your PC!"
          color="lighten-4"
          width="70%"
          max-width="650px"
          height="200"
          class="pt-12"
          v-cloak @drop.prevent="addDropFile" @dragover.prevent
        >
          <v-file-input
            v-model="file"
            color="accent-4"
            counter
            label="File input"
            placeholder="파일 드래그 앤 드롭 & 클릭하여 파일 탐색"
            prepend-icon="mdi-paperclip"
            outlined
            accept=".pdf"
            :show-size="1000"
            ref="fileInput"
          >
          </v-file-input>
          <v-row align="center">
            <v-col class="text-center mt-2">
              <v-btn
                v-if="$store.state.userInfo && $store.state.userInfo.writeWeekly"
                class="mt-4"
                color="primary"
                large
                rounded
                depressed
                @click="upload"
                :disabled="!file"
                >
                등록하기
              </v-btn>
            </v-col>
          </v-row>
        </v-sheet>
      </div>
    </div>
  </article>
</template>

<script>
import { weeklyPaper } from '../api'
import eventBus from '../utils/eventBus'

export default {
  components: {
  },
  data () {
    return {
      file: null
    }
  },
  methods: {
    addDropFile (e) {
      this.file = e.dataTransfer.files[0]
    },
    async upload () {
      try {
        eventBus.$emit('showLoading')
        const formData = new FormData()
        formData.append('sourceFile', this.file)
        await weeklyPaper.create(formData)
        this.file = null
        eventBus.$emit('alert', { active: true, text: '등록 되었습니다.' })
      } catch (e) {
        eventBus.$emit('alert', { active: true, text: '에러! : ' + e.text })
      } finally {
        eventBus.$emit('hideLoading')
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
